namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_range, {
		
		container: {
			type: 'size',
		},
		overflow: 'visible',
		flex: {
			grow: 1,
		},
		
		Body: {
			justify: {
				content: 'center',
			},
			pointerEvents: 'none',
			transition: 'none',
			flex: {
				grow: 0,
			},
			
			Input: {
				zIndex: 1,
				pointerEvents: 'auto',
			},
		},
		
	} )
	
}
